// Organization Model
cv.Organization = Backbone.RESTModel.extend({
  defaults: {
    name: "",
    website: "",
    phone: "",
    line1: "",
    line2: "",
    city: "",
    state: "",
    zipcode: "",
    country: "US",

    billing_line1: "",
    billing_line2: "",
    billing_city: "",
    billing_state: "",
    billing_zipcode: "",
    billing_country: "US",

    last4: "",
  },

  saveMap: {
    name: "name",
    website: "website",
    phone: "phone",

    line1: "line1",
    line2: "line2",
    city: "city",
    state: "state",
    zipcode: "zipcode",
    country: "country",

    customer_id: "customer_id",
    last4: "last4",
    invoice_email: "invoice_email",
    plan: "plan",
    facebook_liked: "facebook_liked",
    twitter_liked: "twitter_liked",
    trial_status: "trial_status",
    trial_limit: "trial_limit",
    trial_alert: "trial_alert",
    site_groups: "site_groups",

    first_name: "first_name",
    last_name: "last_name",
    org_role: "org_role",
    org_type: "org_type",
    org_revenue: "org_revenue",
    org_reason: "org_reason",
    subscribe_tips: "subscribe_tips",
    migrated_at: "migrated_at",
    setup_completed_at: "setup_completed_at",

    enable_branding: "enable_branding",
    brand_logo_path: "brand_logo_path",
    brand_color: "brand_color",

    help_tips: "help_tips",
  },

  urlRoot: function () {
    return cv.api_path + "/organizations";
  },

  initialize: function () {
    console.log("Organization model loaded.");
  },

  getTrialStatus: function () {
    if (parseInt(this.get("trial_status"), 10) < parseInt(this.get("trial_limit"), 10)) {
      return "exceeded";
    } else {
      return "";
    }
  },
});
Cocktail.mixin(cv.Organization, cv.mixins.SyncModel);
